import { render } from "./TheScheduleAdmin.vue?vue&type=template&id=67bfcdd2"
import script from "./TheScheduleAdmin.vue?vue&type=script&lang=js"
export * from "./TheScheduleAdmin.vue?vue&type=script&lang=js"

import "./TheScheduleAdmin.vue?vue&type=style&index=0&id=67bfcdd2&lang=scss"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__